import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllBranch = async ({ limit, page }) => {
    const response = await fetch(`${baseUrl}/api/branch/getallbranches`, {
        method: "GET",
        headers: jwtHeaders(),
        redirect: "follow",
    });

    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();

    return resData;
};
export const fetchParentBranch = async (id) => {
    const response = await fetch(`${baseUrl}/api/owner/getparentbranch/${id}`, {
        method: 'GET',
        headers: jwtHeaders(),
        redirect: 'follow',
    });
    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();

    return resData;
};



export const createBranch = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/branch/create`, {
            method: 'POST',
            body: data,
            headers: jwtHeaders()
        })
        const resData = await response?.json();

        return resData;
    } catch (err) { }
};

export const getBranch = async (branchId) => {
    const response = await fetch(`${baseUrl}/api/branch/getsinglebranch/${branchId}`, {
        method: 'GET',
        headers: jwtHeaders()
    })
    const resData = await response?.json();

    return resData;
};

export const deleteBranch = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/branch/deletebranch/${data}`, {
            method: 'DELETE',
            headers: jwtHeaders(),
        })
        const resData = await response?.json();

        return resData;
    } catch (err) { }
};

export const getFeedbackUrl = async (billId, queryParams) => {
    const response = await fetch(
        `${baseUrl}/api/branch/feedbackpageurl/${billId}${queryParams ? queryParams : ''}`,
        { method: 'GET', headers: jwtHeaders() },
    );
    const resData = response?.json();
    return resData;
};

export const getBillUrl = async (billId) => {
    const response = await fetch(
        `${baseUrl}/api/billing/billpageurl/${billId}`,
        { method: 'GET', headers: jwtHeaders() },
    );
    const resData = response?.json();
    console.log(resData,"resssssData")
    return resData;
};


export const updateGeoLocation = async (branchId, data) => {
    try {
        const response = await fetch(`${baseUrl}/api/branch/updatebranch/${branchId}`, {
            method: 'PUT',
            body: data,
            headers: jwtHeaders()
        })
        const resData = await response?.json();

        return resData;
    }
    catch {

    }
};
export const getBranchTimings = async (branchId) => {
  const response = await fetch(`${baseUrl}/api/branch/getbranchtimings/${branchId}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });
  const resData = await response.json();
  return resData;
};

export const getBranchNotification = async (branchId) => {
  const response = await fetch(`${baseUrl}/api/branch/getbranchnotification/${branchId}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });
  const resData = await response.json();
  return resData;
};